import LaunchIcon from '@mui/icons-material/Launch'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { EntityKpi } from '@components/EntityKpi'
import { MyListButton } from '@components/MyListButton'
import { formatDateTime } from '@util/date-util'

import { AssignedBijlageCaption } from '../../../core/components/AssignedBijlageCaption'
import type { AssignedBijlage } from '../../../entity/bijlagen/types/AssignedBijlage'
import { Label } from '../../../theme/components/Label'
import { StyledIconLink } from '../../../theme/components/StyledIconLink'

interface Props {
  assignedBijlage: AssignedBijlage
}

export const AssignedBijlagenTableRow = ({ assignedBijlage }: Props) => {
  const {
    _id,
    documentsoort,
    assignedTo,
    dueWeek,
    discipline,
    netbeheerder,
    entity: { id: entityId, type: entityType, gebiedscodeLabel },
    searchValues,
    myList,
    title,
    labels,
    kpi,
  } = assignedBijlage
  const { organisatie, date: created } = assignedBijlage.created

  return (
    <TableRow key={_id}>
      <TableCell>
        <EntityKpi kpi={kpi} />
      </TableCell>
      <TableCell>
        {`${title ? `Overig: ${title}` : documentsoort} ${discipline || ''}`}
        <AssignedBijlageCaption assignedBijlage={assignedBijlage} />
      </TableCell>
      <TableCell>{dueWeek}</TableCell>
      <TableCell>{formatDateTime(created)}</TableCell>
      <TableCell>{organisatie}</TableCell>
      <TableCell>
        {assignedTo}
        {netbeheerder && assignedTo !== netbeheerder && (
          <Typography variant="caption">
            <br />
            {`namens ${netbeheerder}`}
          </Typography>
        )}
      </TableCell>
      <TableCell>
        {searchValues?.naam}
        <br />
        <Typography variant="caption">
          <span>#</span>
          {entityId}
        </Typography>
      </TableCell>
      <TableCell>{searchValues?.gemeente}</TableCell>
      <TableCell>
        {gebiedscodeLabel}
        <br />
        {labels && labels.map((l) => <Label text={l} key={l} small={true} />)}
      </TableCell>
      <TableCell>
        <MyListButton
          type="hoofdleiding"
          disabled={true}
          active={myList}
          aanvraagID={''}
        />

        <StyledIconLink
          icon={<LaunchIcon />}
          title={`Navigeer naar ${entityType} ${entityId}`}
          href={`/hoofdleiding/${entityType}/${entityId}`}
        />
      </TableCell>
    </TableRow>
  )
}
